export const USER_ACCEPTS_MARKETING = 'USER_ACCEPTS_MARKETING';

export interface UserAcceptsMarketingAction {
  type: typeof USER_ACCEPTS_MARKETING;
}

export const userAcceptsMarketing = (): UserAcceptsMarketingAction => ({
  type: USER_ACCEPTS_MARKETING
});
